module.exports = __webpack_public_path__ + "img/华尔倍丽.6267c23.png";